/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestItemAttribute from './lab-test-item-attribute';
import LabTestItemAttributeDetail from './lab-test-item-attribute-detail';
import LabTestItemAttributeUpdate from './lab-test-item-attribute-update';
import LabTestItemAttributeDeleteDialog from './lab-test-item-attribute-delete-dialog';

const LabTestItemAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestItemAttribute />} />
    <Route path="new" element={<LabTestItemAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestItemAttributeDetail />} />
      <Route path="edit" element={<LabTestItemAttributeUpdate />} />
      <Route path="delete" element={<LabTestItemAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestItemAttributeRoutes;
